export const SENTRY_CONFIG = {
  DSN: 'https://67de93f10ad041189a9db712349ec92a@o4505090423521280.ingest.sentry.io/4505265969037312',
  ALLOW_ORIGIN: ['localhost', /^https:\/\/v-comply\.com/],
  TRACES_SAMPLE_RATE: 1.0,
  REPLAY_SESSION_SAMPLE_RATE: 0.1,
  REPLAY_ON_ERROR_SAMPLE_RATE: 1.0,
};
